var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C13.0547 20 10.6667 17.612 10.6667 14.6667V8.00002C10.6667 5.05469 13.0547 2.66669 16 2.66669C18.9454 2.66669 21.3334 5.05469 21.3334 8.00002V14.6667C21.3334 17.612 18.9454 20 16 20Z",
    fill: "white",
    fillOpacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M25.4093 17.3547C24.5186 17.1 23.5426 17.4773 23.1213 18.3027C21.7973 20.892 19.108 22.6667 16 22.6667C12.892 22.6667 10.2026 20.892 8.87997 18.3027C8.45864 17.4773 7.48264 17.1 6.59197 17.3547C5.3773 17.7013 4.77864 19.0813 5.36264 20.2013C6.96397 23.2787 9.86664 25.548 13.3346 26.34V26.6667C13.3346 28.14 14.528 29.3333 16.0013 29.3333C17.4746 29.3333 18.668 28.14 18.668 26.6667V26.34C22.136 25.548 25.0386 23.2787 26.64 20.2013C27.2226 19.0813 26.624 17.7013 25.4093 17.3547Z",
    fill: "white",
    fillOpacity: 0.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicLight);
export default __webpack_public_path__ + "static/media/mic-light.a3ca50fb35f274c0cd3320838ec22e57.svg";
export { ForwardRef as ReactComponent };